import { useCallback, useState } from "react";

/**
 * The recipient set. Plain useState on purpose: it lives inside one feature, and hundreds of
 * ids have no business in the URL — a reload dropping the selection is the safe behaviour
 * for a send button.
 */
export function usePushAdminSelection() {
  const [selected, setSelected] = useState<ReadonlySet<number>>(new Set());

  const toggle = useCallback((id: number) => {
    setSelected((prev) => {
      const next = new Set(prev);
      if (next.has(id)) next.delete(id);
      else next.add(id);
      return next;
    });
  }, []);

  const addMany = useCallback((ids: number[]) => {
    setSelected((prev) => {
      const next = new Set(prev);
      ids.forEach((id) => next.add(id));
      return next;
    });
  }, []);

  const clear = useCallback(() => setSelected(new Set()), []);

  return { selected, toggle, addMany, clear };
}
